(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shipping-notice-modal"] && !Shopify.designMode) return;
  try {
    
  function parseDateValue(value) {
    if (!value) return null;
    var parts = value.split('-');
    if (parts.length !== 3) return null;
    var year = parseInt(parts[0], 10);
    var month = parseInt(parts[1], 10);
    var day = parseInt(parts[2], 10);
    if (isNaN(year) || isNaN(month) || isNaN(day)) return null;
    return new Date(year, month - 1, day);
  }

  function isWithinDateRange(now, startDate, endDate) {
    if (startDate) {
      var start = new Date(startDate.getTime());
      start.setHours(0, 0, 0, 0);
      if (now < start) return false;
    }
    if (endDate) {
      var end = new Date(endDate.getTime());
      end.setHours(23, 59, 59, 999);
      if (now > end) return false;
    }
    return true;
  }

  function getFrequencyIntervalMs(frequency) {
    if (frequency === 'daily') return 24 * 60 * 60 * 1000;
    if (frequency === 'weekly') return 7 * 24 * 60 * 60 * 1000;
    return 0;
  }

  function getStoredLastSeen() {
    try {
      return parseInt(localStorage.getItem('shippingNoticeLastSeen') || '0', 10);
    } catch (error) { return 0; }
  }

  function storeLastSeen(timestamp) {
    try { localStorage.setItem('shippingNoticeLastSeen', String(timestamp)); } catch (error) { return; }
  }

  function closeShippingNoticeModal(modal) {
    if (!modal) return;
    modal.style.display = 'none';
    document.body.style.overflow = '';
    storeLastSeen(Date.now());
  }

  function openShippingNoticeModal(modal) {
    if (!modal) return;
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  function shouldShowModal(modal) {
    if (!modal) return false;
    if (modal.dataset.enabled !== 'true') return false;

    var now = new Date();
    var startDate = parseDateValue(modal.dataset.startDate);
    var endDate = parseDateValue(modal.dataset.endDate);
    if (!isWithinDateRange(now, startDate, endDate)) return false;

    var frequency = modal.dataset.frequency || 'every_refresh';
    if (frequency === 'every_refresh') return true;

    var lastSeen = getStoredLastSeen();
    if (!lastSeen) return true;

    var interval = getFrequencyIntervalMs(frequency);
    return now.getTime() - lastSeen >= interval;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var modal = document.getElementById('ShippingNoticeModal');
    if (!modal) return;

    var slider = document.getElementById('ft-modal-slider');
    var dots = document.querySelectorAll('.shipping-notice-modal__dot');
    var prevBtn = document.querySelector('.ft-carousel-prev');
    var nextBtn = document.querySelector('.ft-carousel-next');
    
    var totalSlides = dots.length;
    var currentIndex = 0;
    var autoSlideTimer;
    
    var isAutoSlide = modal.dataset.autoSlide === 'true';
    var slideInterval = parseInt(modal.dataset.slideInterval || '5000', 10);

    function goToSlide(index) {
      if (!slider) return;
      if (index < 0) index = totalSlides - 1; 
      if (index >= totalSlides) index = 0; 
      currentIndex = index;
      slider.scrollTo({ left: slider.clientWidth * currentIndex, behavior: 'smooth' });
      resetAutoSlide();
    }

    if (slider && totalSlides > 1) {
      
      if (prevBtn) prevBtn.addEventListener('click', function() { goToSlide(currentIndex - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function() { goToSlide(currentIndex + 1); });

      dots.forEach(function(dot, i) {
        dot.addEventListener('click', function() { goToSlide(i); });
      });

      var scrollTimeout;
      slider.addEventListener('scroll', function() {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function() {
          var index = Math.round(slider.scrollLeft / slider.clientWidth);
          currentIndex = index;
          dots.forEach(function(dot, i) {
            if (i === index) dot.classList.add('is-active');
            else dot.classList.remove('is-active');
          });
        }, 50);
      });

      function startAutoSlide() {
        if (isAutoSlide && totalSlides > 1) {
          autoSlideTimer = setInterval(function() {
            goToSlide(currentIndex + 1);
          }, slideInterval);
        }
      }
      function resetAutoSlide() {
        clearInterval(autoSlideTimer);
        startAutoSlide();
      }

      var container = document.querySelector('.shipping-notice-modal__container');
      if(container) {
        container.addEventListener('mouseenter', function() { clearInterval(autoSlideTimer); });
        container.addEventListener('mouseleave', function() { startAutoSlide(); });
      }

      startAutoSlide();
    }

    var closeButtons = modal.querySelectorAll('[data-shipping-notice-close]');
    closeButtons.forEach(function(btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        closeShippingNoticeModal(modal);
        clearInterval(autoSlideTimer); 
      });
    });

    if (shouldShowModal(modal)) {
      openShippingNoticeModal(modal);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
